
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 20a5 5 0 11-5-5 5 5 0 015 5z"}}),_c('path',{attrs:{"d":"M20 5a15 15 0 1015 15A15 15 0 0020 5zm0 25a10 10 0 1110-10 10 10 0 01-10 10z"}})])
          )
        }
      }
    